import { render, staticRenderFns } from "./auditionList.vue?vue&type=template&id=60ed02a3&scoped=true&"
import script from "./auditionList.vue?vue&type=script&lang=js&"
export * from "./auditionList.vue?vue&type=script&lang=js&"
import style0 from "./auditionList.vue?vue&type=style&index=0&id=60ed02a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ed02a3",
  null
  
)

export default component.exports